import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_SOURCE_LIST, GET_SOURCE_LIST_SUCCESS, GET_SOURCE_LIST_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getSourceList({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/sources`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_SOURCE_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_SOURCE_LIST_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_SOURCE_LIST_ERROR, payload: error });
  }
}

export function* watchGetSourceList() {
  yield takeEvery(GET_SOURCE_LIST, getSourceList);
}

function* getSourceListSaga() {
  yield all([fork(watchGetSourceList)]);
}

export default getSourceListSaga;
